import React from 'react';
import PropTypes from 'prop-types';
import { groupBy } from 'lodash';
import CategoryAccordion from './CategoryAccordion';
import useCustomFieldsCategories from '../../../../../hooks/useCustomFieldsCategories';

const propTypes = {
  inventoryCustomFields: PropTypes.arrayOf(PropTypes.object),
  basePath: PropTypes.string,
  refetch: PropTypes.func,
};

function CustomFieldsView({ inventoryCustomFields, basePath, refetch }) {
  const { categories, refetch: refreshCategories } = useCustomFieldsCategories();

  const groupedFields = groupBy(inventoryCustomFields, 'categoryId');
  return categories?.map((category, index) => {
    return (
      <CategoryAccordion
        basePath={basePath}
        key={category.id}
        categoryFields={groupedFields[category.id] || []}
        category={category}
        refetch={refetch}
        refreshCategories={refreshCategories}
        index={index}
      />
    );
  });
}

CustomFieldsView.propTypes = propTypes;

export default CustomFieldsView;
